<template>
    <div
        v-if="deckMap"
        v-show="deckMapReceived || deckMap === 'change'"
        class="deckmapview-container"
        style="pointer-events: all;"
    >
        <div class="header">
            <h3>Kies je dek</h3>
          <div style="float: left;margin-left: 10px;margin-top: -5px;clear:initial" class="select-drop">
            <select
                v-model="cabinNumbers.selected"
                v-on:change="$emit('getDeckMap-click')"
            >
              <option
                  v-for="(option,
                                            index) in cabinDeckNumbers()"
                  :key="'CabinNumberSelect' + index"
                  :value="option"
                  v-if="option !== undefined"
              >
              Dek  {{ index }}
              </option>
            </select>
          </div>
            <a
                href="javascript:void(0)"
                class="closebtn"
                v-on:click="toggleDeckMap()"
                ><font-awesome-icon icon="times"
            /></a>
            <div class="clearfix"></div>
        </div>

        <div class="deckmap-container">
          <div v-if="deckMapReceived">
            <div class="area-container">
              <div
                  v-for="(area, index) in areas"
                  :id="'div-' + area.id"
                  :key="'area-container-div-' + index"
                  :class="[area.class, 'highlight', 'overlay']"
                  :style="{
                        left: area.left + 'px',
                        top: area.top + 'px',
                        width: area.width + 'px',
                        height: area.height + 'px',
                    }"
                  :orgCoords="area.orgCoords"
                  v-on:click="areaClick(area)"
              ></div>
            </div>
            <div id="deckmap-content" v-html="deckMap.html"></div>
          </div>
            <div v-else style="display: flex; text-align: center;flex-flow: column; justify-content: center;height:100%;">
              <font-awesome-icon icon="spinner" :spin="true" style="font-size:48px;margin:auto"/>
            </div>
        </div>

        <div class="footer" v-if="cabinNumbers && cabinNumbers.selected">
            <h3>Geselecteerde hut: {{ cabinNumbers.selected }}</h3>
            <button
                v-on:click="toggleDeckMap()"
                class="btn confirm-btn btn-success btn-addon font14 bold floatright"
            >
                Hut bevestigen
            </button>
            <div class="clearfix"></div>
        </div>

        <div class="dim"   v-on:click="toggleDeckMap()"></div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

library.add(faTimes)

export default {
    name: 'DeckMap',
    data: function() {
        return { areas: [] }
    },
    props: {
        cabinNumbers: Object,
        deckMap: Object,
        deckMapReceived: Boolean,
        showDeckMap: Boolean,
        toggleDeckMap: Function,
    },
    watch: {
        showDeckMap: function(value) {
            let self = this
            if (value === false) return false
            setTimeout(function() {
                self.drawCabins()
                self.scrollView(self.cabinNumbers.selected)
            }, 200)
        },
        deckMap: function(value) {
            let self = this
            if (value === null) return false

            setTimeout(function() {
                self.drawCabins()
            }, 200)
        },
    },
    methods: {
        areaClick: function(area) {
            if (area.available) {
                this.cabinNumbers.selected = area.id
                this.drawCabins()
            }
        },
        scrollView: function(cabinnr) {
            let cabinDiv = $('#div-' + cabinnr)

            if (Array.isArray(cabinDiv) && cabinDiv.length > 0) {
                cabinDiv[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                })
                $('.deckmap-container').scrollTop(
                    $('.deckmap-container').scrollTop() - 100
                )
            }
        },

        cabinDeckNumbers: function() {

          if(this.cabinNumbers) {

            let cabinDecks = [];

            this.cabinNumbers.options.forEach(function(
                cabin
            ) {
              let cabinDeck = cabin.substring(0,1);

             if(cabin.length === 5) {
               cabinDeck = cabin.substring(0,2)
             }

             if(cabinDeck !== 'G' && !cabinDecks.includes(cabin)) {
               cabinDecks[cabinDeck] = cabin;
             }
            })
            if(this.cabinNumbers.selected) {
              let cabin = this.cabinNumbers.selected;
              let cabinDeck = cabin.substring(0,1);

              if(cabin.length === 5) {
                cabinDeck = cabin.substring(0,2)
              }

              if(cabinDeck !== 'G' && !cabinDecks.includes(cabin)) {
                cabinDecks[cabinDeck] = cabin;
              }
            }

            return cabinDecks
          }
          return []
          },
        drawCabins: function() {
            if (
                !this.deckMap ||
                this.deckMap === 'change' ||
                this.deckMap.html === '' ||

                this.deckMap.html === null
            )
                return false
            //go trough each area within map
            let options = this.cabinNumbers.options //store options
            let self = this
            let image = document.querySelector('#deckmap-content img')
            let modWidth = image.width / (image.getAttribute('orgwidth') !== null ? image.getAttribute('orgwidth') : image.naturalWidth)
            let modHeight = image.height / (image.getAttribute('orgheight') !== null ? image.getAttribute('orgheight') : image.naturalHeight)

            self.areas = []
            $('#deckmap-content > map > area').each(function() {
                let area = this //store area
                let coords = area.coords; //get area coords

                coords = coords.split(',') //split coords on coma

                coords = coords.map(s => s.trim());


              //TODO in case area coords are more than 4, calculate from the highest and lowest values
                let width = parseInt(coords[2] - coords[0]) //calculate box width
                let height = parseInt(coords[3] - coords[1]) //calculate box height

                //default availability
                let availability = 'unavailable'
                let available = false
                let selected = false

                let my_id = area.id.replace(/[^0-9]/g, '')

                if ($.inArray(my_id, options) !== -1) {
                    availability = 'available' //set availability to available for this cabin
                    available = true
                    //check if cabin is selected as well
                    if (my_id == self.cabinNumbers.selected) {
                        availability += ' selected' //add selected to end
                        selected = true
                    }
                }
                self.areas.push({
                    id: my_id,
                    class: availability,
                    left: Math.floor(Number(coords[0]) * modWidth),
                    top: Math.floor(Number(coords[1]) * modHeight) + 50,
                    width: Math.floor(width * modWidth),
                    height: Math.floor(height * modHeight),
                    orgCoords: coords,
                    available: available,
                    selected: selected,
                })

            })
        },
    },
}
</script>

<style lang="scss">
.deckmapview-container {
    background-color: #fff;
    position: relative;
    height: 100%;
    overflow: hidden;

    .dim {
        position: fixed;
        left: 0;
        top: 0;
        width: 60%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.75);
        z-index: -1 !important;
    }

    .header,
    .footer {
        z-index: 11;
        position: absolute;
        padding: 10px;
        width: 100%;
        background-color: #f8f8f8;
        -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.75);
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.75);
    }

    .header {
        height: 30px;
        top: 0;

        .closebtn {
            background-color: #8d8d8d;
            padding: 5px;
            margin-right: 20px;
            width: 20px;
            height: 20px;
            text-align: center;
            border-radius: 100%;
            color: #f8f8f8;
            font-size: 20px;
            float: right;
        }
    }

    .footer {
        height: 50px;
        bottom: 0;

        h3 {
            line-height: 50px !important;
        }

        .confirm-btn {
            margin: 5px 20px 0 0;
        }
    }

    h3 {
        float: left;
        margin: 0;
        line-height: 30px;
    }

    #deckmap-content,
    .deckmap-container .area-container {
        margin: 25px auto;
        width: 350px !important;
        position: relative;
    }

    .deckmap-container {
        height: calc(100% - 120px);
        margin: 50px 0 70px 0;
        z-index: 11;
        overflow: auto;
        scroll-behavior: smooth;

        .area-container {
            width: 100%;
            top: -50px;
            height: auto;
            position: relative;

            .highlight {
                position: relative;
                z-index: 10000;
                vertical-align: middle;
                text-align: center;
            }

            .selected {
                background-color: rgba(40, 255, 46, 0.9) !important;
                color: black !important;
                outline: 2px solid #000;
                -webkit-animation: pulsate-bck 1s ease-in-out infinite both;
                animation: pulsate-bck 1s ease-in-out infinite both;
            }

            .unavailable {
                background: -webkit-radial-gradient(
                    circle,
                    rgba(235, 69, 0, 1),
                    rgba(255, 92, 92, 0)
                );
                background: -moz-radial-gradient(
                    circle,
                    rgba(235, 37, 37, 1),
                    rgba(255, 92, 92, 0)
                );
                background: radial-gradient(
                    ellipse at center,
                    rgba(255, 92, 82, 1),
                    rgba(255, 92, 92, 0)
                );
            }

            .available {
                background-color: rgba(0, 255, 15, 0.5);
                outline: 2px solid #000;
                cursor: pointer;
            }

            .overlay {
                position: absolute;
                top: 0;
                left: 0;
                color: #fff;
            }
        }
    }
}

@-webkit-keyframes pulsate-bck {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    50% {
        -webkit-transform: scale(0.95);
        transform: scale(0.95);
    }
    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}
@keyframes pulsate-bck {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    50% {
        -webkit-transform: scale(0.95);
        transform: scale(0.95);
    }
    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}
</style>
